import { properties } from "@dinahmoe/dmafjs-core";
import { Text } from "./text.component.js";

class Input extends Text {
  namespace = "visual:text:input";

  receiveMessage(cNode, message) {
    switch (message.key) {
      case "content_updated": {
        // all inputs in HTML are of type string, moreover we have a descriptor that states the content property is string
        cNode["text.content"] = message.value.content.toString();
        cNode["input.isValid"] = message.value.isValid;
        break;
      }
      case "height_updated": {
        if (!properties.isLinked(cNode.uid, "size.height")) {
          cNode["size.height"] = message.value.height;
        }
        break;
      }
      default: {
        super.receiveMessage(cNode, message);
        break;
      }
    }
  }
}

const input = new Input();
export { Input, input };
